import { render, staticRenderFns } from "./RPDropdownButton.vue?vue&type=template&id=c318a4ba&"
import script from "./RPDropdownButton.vue?vue&type=script&lang=js&"
export * from "./RPDropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./RPDropdownButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPDropdownButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports